import React from 'react';
import styles from './timeline.module.scss';
import * as dateFns from 'date-fns';

interface ITimelineProps {
  currentTime: Date;
  containerStyle?: React.CSSProperties;
}

export const Timeline: React.FC<ITimelineProps> = ({
  currentTime,
  containerStyle = {},
}) => {
  const timeString = dateFns.format(currentTime, 'HH:mm');

  return (
    <div className={styles.timeline__container} style={containerStyle}>
      <div className={styles.timeline__line}></div>
      <div className={styles.timeline__time}>{timeString}</div>
      <div className={styles.timeline__line}></div>
    </div>
  );
};
